'use strict';

import ngResource from 'angular-resource';

function ExternalApiCredentialService ($resource) {
    return $resource(
        '/api/oem/external_api_credential',
        { },
        {
            index : { method: 'GET',  isArray: false },
            create: { method: 'POST', isArray: false }
        }
    );
 }

export default angular.module('leptonApp.ExternalApiCredentialService', ['ngResource'])
    .service('ExternalApiCredentialService', ['$resource', ExternalApiCredentialService])
    .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/external_api_credential/external_api_credential.service.js